// extracted by mini-css-extract-plugin
module.exports = {"container":"frequenti_container__esS_J","holder":"frequenti_holder__gJEIV","title":"frequenti_title__pb0Im"};